/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c570167a89ec0db2885446f6c8a64864b5bebf86";
